import { render } from "./Header.vue?vue&type=template&id=4c02736b&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=4c02736b&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/spinwheel-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c02736b"]])

export default __exports__